// ── V118: 단가표 구매 링크 ────────────────────────────────────────────────
// 온라인으로 사는 품목(타오바오·징둥·1688·쿠팡 등)은 제품 링크를 넣어두면
// 단가표·발주서에서 바로 열어 다시 주문할 수 있다.
//
// 타오바오 "공유" 버튼은 링크 앞뒤에 설명이 붙은 문장을 복사해 준다.
//   예) 【淘宝】https://m.tb.cn/h.TxGkv0r?tk=AbCd HU9196 「맛소금 1kg」 点击链接直接打开
// 이걸 통째로 붙여넣어도 링크만 뽑아 저장한다.
//
// 화면에서는 http/https 주소만 연다. javascript: 같은 위험한 주소는 절대 링크로 만들지 않는다.

// 링크가 끝나는 곳: 공백, 따옴표·꺾쇠, 중국어/전각 문장부호(、。「」【】，！ 등)
const URL_IN_TEXT = /https?:\/\/[^\s"'<>　-〿！-／：-＠]+/i;
const BARE_DOMAIN = /^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)+(\/\S*)?$/i;

/** 붙여넣은 글에서 열 수 있는 http(s) 링크를 뽑는다. 못 찾으면 '' */
export function cleanPurchaseLink(input) {
  const s = String(input == null ? '' : input).trim();
  if (!s) return '';
  let url = (s.match(URL_IN_TEXT) || [])[0] || '';
  if (!url && BARE_DOMAIN.test(s)) url = 'https://' + s;   // "item.jd.com/100.html" 처럼 주소만
  if (!url) return '';
  url = url.replace(/[)\]}>.,;:!?'"]+$/, '');                // 문장 끝 부호가 딸려 온 경우
  try {
    const u = new URL(url);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
    if (!u.hostname.includes('.')) return '';
    return u.href;
  } catch {
    return '';
  }
}

/** 저장용: 링크를 뽑을 수 있으면 링크만, 못 뽑으면 적은 그대로 둔다(화면에 '링크 아님' 표시) */
export function normalizeLinkInput(input) {
  const raw = String(input == null ? '' : input).trim();
  if (!raw) return '';
  return cleanPurchaseLink(raw) || raw;
}

/** 화면에서 열어도 되는 주소. 아니면 null */
export function safeLinkHref(link) {
  return cleanPurchaseLink(link) || null;
}

const SITE_NAMES = [
  [/(^|\.)(taobao\.com|tb\.cn)$/i, '淘宝'],
  [/(^|\.)tmall\.com$/i, '天猫'],
  [/(^|\.)(jd\.com|3\.cn)$/i, '京东'],
  [/(^|\.)1688\.com$/i, '1688'],
  [/(^|\.)(pinduoduo\.com|yangkeduo\.com)$/i, '拼多多'],
  [/(^|\.)coupang\.com$/i, '쿠팡'],
  [/(^|\.)naver\.com$/i, '네이버'],
];

/** 표시용 짧은 이름 — 알려진 쇼핑몰은 이름으로, 나머지는 도메인 */
export function linkLabel(link) {
  const href = safeLinkHref(link);
  if (!href) return '';
  let host = '';
  try { host = new URL(href).hostname; } catch { return ''; }
  for (const [re, name] of SITE_NAMES) if (re.test(host)) return name;
  return host.replace(/^(www|m|item|detail)\./i, '');
}
